var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.customer
        ? [
            _c("div", [
              _vm._v("\n\t\t\t" + _vm._s(_vm.customer.fullName) + "\n\t\t\t"),
              _vm.customer.role
                ? _c("span", [_vm._v("(" + _vm._s(_vm.customer.role) + ")")])
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.customer.dataComplete
              ? _c(
                  "div",
                  { staticClass: "mt-3 text-right" },
                  [
                    _c("Button", {
                      attrs: {
                        text: "Meine Daten vervollständigen",
                        icon: "edit"
                      },
                      on: {
                        click: function($event) {
                          _vm.showPopUp = true
                        }
                      }
                    })
                  ],
                  1
                )
              : _c("div", { staticClass: "mt-3" }, [
                  _c("div", { staticClass: "mt-4" }, [
                    _c("div", { staticClass: "font-weight-bold" }, [
                      _vm._v("Firmendaten")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.companyName))]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.customer.street) +
                          " " +
                          _vm._s(_vm.customer.streetNumber) +
                          ",\n\t\t\t\t\t" +
                          _vm._s(_vm.customer.zip) +
                          " " +
                          _vm._s(_vm.customer.city) +
                          ",\n\t\t\t\t\t" +
                          _vm._s(_vm.customer.country.text) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.customer.companyNumber
                      ? _c("div", [_vm._v(_vm._s(_vm.customer.companyNumber))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customer.vatNumber
                      ? _c("div", [_vm._v(_vm._s(_vm.customer.vatNumber))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customer.website
                      ? _c("div", [_vm._v(_vm._s(_vm.customer.website))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.customer.externalCompanyName
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c("div", { staticClass: "font-weight-bold" }, [
                          _vm._v("Auftraggeber-Daten")
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.customer.externalCompanyName))
                        ]),
                        _vm._v(" "),
                        _vm.customer.externalCompanyNumber
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.customer.externalCompanyNumber))
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2 text-right" },
                    [
                      _c("Button", {
                        attrs: { text: "Daten bearbeiten", icon: "edit" },
                        on: {
                          click: function($event) {
                            _vm.showPopUp = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showPopUp
        ? _c(
            "PopUp",
            {
              attrs: { title: "Meine Daten", size: "xl", "hide-actions": "" },
              on: {
                hidden: function($event) {
                  _vm.showPopUp = false
                }
              }
            },
            [
              _vm.customer
                ? _c("CompleteData", {
                    attrs: {
                      "with-personal-data": true,
                      customer: _vm.customer,
                      "data-complete": _vm.customer.dataComplete
                    },
                    on: { complete: _vm.onComplete }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }